import deposit from '@/api/accounting/company-deposit'
import dealer from '@/api/administrator/dealer-profile'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  date_from: moment()
    .add(-1, 'Day')
    .format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to
      },
      attrubutes
    )
    return deposit.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return deposit.store(data)
  },
  getTransactionType(context) {
    return deposit.getTran()
  },
  getDealer(context) {
    return dealer.get({
      params: {
        filter: {
          dealer_type_id: 1
        },
        fields: {
          dealer_profiles:
            'dealer_id,dealer_name,topup_commission_rate,payout_commission_rate,dealer_address,id_passport_no,dealer_code,primary_contact,secondary_contact'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
